// VFX: Glitch Text Reveal
// Category: char-reveals · Tags: text, glitch, cyberpunk, jhey
// Text appears with digital glitch/displacement effect.
import { AbsoluteFill, useCurrentFrame, useVideoConfig, interpolate, random } from "remotion";
import React from "react";

const TEXT = "GLITCH";

export default function TextGlitchRevealCyberpunk800Ms() {
  const frame = useCurrentFrame();
  const { width, height } = useVideoConfig();
  const glitchIntensity = interpolate(frame, [0, 8, 18], [24, 12, 0], { extrapolateRight: "clamp" });
  const opacity = interpolate(frame, [0, 6], [0, 1], { extrapolateRight: "clamp" });
  const offsetX = random(`gx-${frame}`) * glitchIntensity - glitchIntensity / 2;
  const offsetY = random(`gy-${frame}`) * glitchIntensity - glitchIntensity / 2;
  const sliceCount = 6;

  return (
    <AbsoluteFill style={{ background: "#0a0e1a", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
      {Array.from({ length: sliceCount }).map((_, i) => {
        const sliceOffset = (random(`s-${i}-${Math.floor(frame / 2)}`) - 0.5) * glitchIntensity * 2;
        const clip = `polygon(0 ${(i / sliceCount) * 100}%, 100% ${(i / sliceCount) * 100}%, 100% ${((i + 1) / sliceCount) * 100}%, 0 ${((i + 1) / sliceCount) * 100}%)`;
        return (
          <div key={i} style={{
            position: "absolute", width, height,
            display: "flex", justifyContent: "center", alignItems: "center",
            clipPath: clip, transform: `translate(${sliceOffset + offsetX}px, ${offsetY}px)`,
            opacity,
            fontFamily: "monospace", fontSize: Math.min(width, height) * 0.18, fontWeight: 900,
            color: "#f8fafc",
            textShadow: glitchIntensity > 2 ? `${-glitchIntensity}px 0 #ff0040, ${glitchIntensity}px 0 #00ff88` : "none",
            letterSpacing: 4,
          }}>{TEXT}</div>
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
